
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_lm6vo_qxaqe_98",
  "resize-side": "awsui_resize-side_lm6vo_qxaqe_104",
  "resize-bottom": "awsui_resize-bottom_lm6vo_qxaqe_107",
  "with-motion": "awsui_with-motion_lm6vo_qxaqe_112",
  "root": "awsui_root_lm6vo_qxaqe_127",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_qxaqe_128",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_qxaqe_135",
  "layout": "awsui_layout_lm6vo_qxaqe_128",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_qxaqe_146",
  "layout-main": "awsui_layout-main_lm6vo_qxaqe_150",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_qxaqe_156",
  "unfocusable": "awsui_unfocusable_lm6vo_qxaqe_161",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_qxaqe_165",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_qxaqe_170",
  "content-wrapper": "awsui_content-wrapper_lm6vo_qxaqe_174",
  "content-overlapped": "awsui_content-overlapped_lm6vo_qxaqe_178",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_qxaqe_182"
};
  